import { useContext } from 'react';
import dataApplicationsContext from '../context/dataApplicationsContext';

// Rôle unique : useHasRole(ROLES.ADMIN)
export function useHasRole(roleId) {
  const { auth } = useContext(dataApplicationsContext);
  const roleIds = auth?.user?.roles_ids || [];
  return roleIds.includes(roleId);
}

// Plusieurs rôles acceptés : useHasAnyRole([ROLES.ADMIN, ROLES.ENTRAINEUR])
export function useHasAnyRole(roleIds = []) {
  const { auth } = useContext(dataApplicationsContext);
  const userRoleIds = auth?.user?.roles_ids || [];
  return roleIds.some((id) => userRoleIds.includes(id));
}